import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { Row, Table, Modal } from 'antd';
import isEqual from 'lodash/isEqual';

import * as pageActions from '../../../../../data/redux/page_details/actions';
import * as eventActions from '../../../../../data/redux/event_details/actions';

import { APP_PAGES, PERMISSIONS } from '../../../../../data/config/constants';
import { uniqueId, showMessage } from '../../../../../data/config/utils';
import { IMG_ERROR } from '../../../../../data/assets/img';

import ErrorBoundary from '../../../../../components/errorboundary';
import CustomHeader from '../../../../../components/customheader';
import CommonForm from '../../../../../components/commonform';
import TableCellAction from '../../../components/tablecellaction';
import PageHeaderLoader from '../../../../../components/pageheader/loaders';
import CardRowTableLoader from '../../../components/loaders/cardrowtable';
import ShowMessage from '../../../../../components/showmessage';

class Events extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal_data: {
                title: "",
                show_create_event: false,
                show_edit_event: false,
            },
            current_event: {},
            search_text: "",
            filtered_events: props.event_details.events
        };
        this.columns = [
            {
                title: 'Tag',
                dataIndex: 'tag',
                key: 'tag',
                className: "ori-font-bold ori-capitalize-first",
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
            },
            {
                title: 'Last Updated',
                dataIndex: 'updatedAt',
                key: 'updatedAt',
                render: (text) => {
                    return (
                        <div>{moment(text).format('DD MMM YYYY')}</div>
                    );
                }
            },
            {
                title: 'Action',
                dataIndex: 'Action',
                key: 'Action',
                render: (text, record) => {
                    return (
                        <TableCellAction show_edit={record.canModify} show_delete={record.canModify} delete_popconfirm_title="Are you sure delete this event?" handleEditClick={() => this.handleEditEvent(record)} handleDeleteClick={() => this.handleDeleteEvent(record)} />
                    );
                }
            }
        ];
    }

    componentWillMount() {
        const { actions } = this.props;
        actions.pageChanged(APP_PAGES.EVENTS, APP_PAGES.BOT_BUILDER);
    }

    componentDidMount() {
        this.props.actions.getEventsData();
    }

    componentWillReceiveProps(nextProps) {
        const { event_details } = this.props;
        const { search_text } = this.state;
        if (!isEqual(nextProps.event_details.events, event_details.events)) {
            const table_data = [...nextProps.event_details.events];
            if (search_text.trim().length !== 0) {
                this.setState({
                    filtered_events: this.filterEventBySearchText(search_text, table_data)
                });
            } else {
                this.setState({
                    filtered_events: table_data
                });
            }
        }
    }

    filterEventBySearchText = (text, events) => {
        return events.filter((event) => {
            return (event && event.tag && event.tag !== undefined && event.tag.toLowerCase().indexOf(text.toLowerCase()) !== -1 || event && event.description && event.description !== undefined && event.description.toLowerCase().indexOf(text.toLowerCase()) !== -1)
        });
    };

    handleEventSearch = (event) => {
        const search_text = event.target.value;
        const { event_details } = this.props;
        this.setState({ search_text });
        if (search_text.trim().length !== 0) {
            this.setState({
                filtered_events: this.filterEventBySearchText(search_text, event_details.events)
            });
        } else {
            this.setState({
                filtered_events: event_details.events
            });
        }
    };

    updateCurrentEvent = (key, value) => {
        this.setState((state) => {
            return {
                current_event: {
                    ...state.current_event,
                    [key]: value
                }
            }
        })
    };

    onDeselectTagType = (tag) => {
        const { current_event } = this.state;
        if (current_event.includeInReportTagType && current_event.includeInReportTagType.length > 0) {
            const index = current_event.includeInReportTagType.findIndex(item => item === tag);
            if (index !== -1) {
                const data = [...current_event.includeInReportTagType.slice(0, index), ...current_event.includeInReportTagType.slice(index + 1)];
                this.updateCurrentEvent('includeInReportTagType', data);
            }
        }
        if (current_event.includeInDashboardTagType && current_event.includeInDashboardTagType.length > 0) {
            const index = current_event.includeInDashboardTagType.findIndex(item => item === tag);
            if (index !== -1) {
                const data = [...current_event.includeInDashboardTagType.slice(0, index), ...current_event.includeInDashboardTagType.slice(index + 1)];
                this.updateCurrentEvent('includeInDashboardTagType', data);
            }
        }
    };

    handleCreateEvent = () => {
        const { isActionPermitted } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.EVENT, PERMISSIONS.ACTION_TYPES.CREATE)) {
            this.setState({
                modal_data: {
                    title: "Create Event",
                    show_create_event: true,
                    show_edit_event: false,
                },
            });
        } else {
            showMessage('warning', 'You have not permission to create event.');
        }
    };

    handleEditEvent = (event) => {
        const { isActionPermitted, actions } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.EVENT, PERMISSIONS.ACTION_TYPES.UPDATE)) {
            const payload = { eventId: event.eventId };
            actions.getEventDetails(payload, (event_data) => {
                this.setState({
                    current_event: event_data,
                    modal_data: {
                        title: "Edit Event",
                        show_create_event: false,
                        show_edit_event: true,
                    },
                });
            });
        } else {
            showMessage('warning', 'You have not permission to update event.');
        }
    };

    handleDeleteEvent = event => {
        const { isActionPermitted } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.EVENT, PERMISSIONS.ACTION_TYPES.DELETE)) {
            const payload = { eventId: event.eventId };
            this.props.actions.deleteEvent(payload);
        } else {
            showMessage('warning', 'You have not permission to delete any event.');
        }
    };

    handleFormSubmit = () => {
        const { modal_data, current_event } = this.state;
        const { actions } = this.props;
        if (modal_data.show_create_event) {
            actions.createEvent(current_event, this.closeModal);
        } else if (modal_data.show_edit_event) {
            actions.updateEvent(current_event, this.closeModal);
        }
    };

    closeModal = () => {
        this.setState({
            current_event: {},
            modal_data: {
                title: '',
                show_create_event: false,
                show_edit_event: false
            }
        });
    };

    onChangeCurrentEvent = event => {
        this.setState({
            current_event: {
                ...this.state.current_event,
                [event.target.name]: event.target.value
            }
        });
    };

    onChangeTagType = tagTypes => {
        this.updateCurrentEvent('tagType', tagTypes);
    };

    onChangeIncludeInReportTagType = tagTypes => {
        this.updateCurrentEvent('includeInReportTagType', tagTypes);
    };

    onChangeIncludeInDashboardTagType = tagTypes => {
        this.updateCurrentEvent('includeInDashboardTagType', tagTypes);
    };

    onChangeSwitch = (value, event) => {
        this.setState({
            current_event: {
                ...this.state.current_event,
                [event.target.name]: value
            }
        });
    };

    renderEventCommonForm = () => {
        const { event_details } = this.props;
        const { modal_data, current_event } = this.state;
        if (modal_data.show_create_event || modal_data.show_edit_event) {
            const first_input_props = {
                title: "Tag",
                placeholder: "Enter Event Name",
                name: "tag",
                value: current_event.tag,
                autoFocus: true,
                onChange: this.onChangeCurrentEvent,
            };
            const first_textarea_props = {
                title: "Description",
                placeholder: "Write description ...",
                value: current_event.description,
                name: "description",
                onChange: this.onChangeCurrentEvent,
            };
            const first_select_props = {
                title: "Tag types",
                placeholder: "Select Tag Types",
                mode:"multiple",
                options: options,
                value: current_event.tagType,
                onChange: this.onChangeTagType,
                onDeselect: this.onDeselectTagType,
            };
            const second_select_props = {
                title: "Include in report tag types",
                placeholder: "Include in Report Tag Types",
                mode:"multiple",
                options: current_event.tagType,
                value: current_event.includeInReportTagType,
                onChange: this.onChangeIncludeInReportTagType,
            };
            const third_select_props = {
                title: "Include in dashboard tag types",
                placeholder: "Include in Dashboard Tag Types",
                mode:'multiple',
                options: current_event.tagType,
                value: current_event.includeInDashboardTagType,
                onChange: this.onChangeIncludeInDashboardTagType,
            };
            const first_switch_props = {
                switch_first: true,
                title:"Do you want to include in report's tag type",
                name: "includeInReports",
                checked:current_event.includeInReports,
                onChange: this.onChangeSwitch
            };
            const second_switch_props = {
                switch_first: true,
                title:"Do you want to include in dashboard's tag type",
                name: "includedInDashboard",
                checked: current_event.includedInDashboard,
                onChange: this.onChangeSwitch
            };
            const modal_footer_props = {
                loading: event_details.loaders.event_updating,
                button_ok_text: modal_data.show_create_event ? "Create" : "Update",
                handleCancelClick: this.closeModal,
                handleOkClick: this.handleFormSubmit,
            };
            return (
                <ErrorBoundary onErrorCallback={this.closeModal}>
                    <CommonForm 
                        show_first_input 
                        show_first_textarea
                        show_first_select 
                        show_first_switch 
                        show_second_switch
                        show_second_select={current_event.includeInReports}
                        show_third_select={current_event.includedInDashboard}
                        first_input_props={first_input_props} 
                        first_textarea_props={first_textarea_props} 
                        first_select_props={first_select_props} 
                        second_select_props={second_select_props} 
                        third_select_props={third_select_props}
                        first_switch_props={first_switch_props}
                        second_switch_props={second_switch_props}
                        modal_footer_props={modal_footer_props}   
                    />
                </ErrorBoundary>
            );
        }
    };

    render() {
        const { page_details, event_details } = this.props;
        const { modal_data } = this.state;
        const mobile = page_details.device_data.screen_width < 768;

        if (event_details.loaders.events_loading && !event_details.loaders.events_loaded) {
            return (
                <div className="ori-full-parent-height oriBotMessagesContainer">
                    <PageHeaderLoader container_class="ori-lr-pad-10" bottom_bordered />
                    <div className="ori-pad-10">
                        <CardRowTableLoader />
                    </div>
                </div>
            );
        }
        else if (!event_details.loaders.events_loading && event_details.loaders.events_loaded) {
            return (
                <Row className="ori-lr-pad-10 orieventscontainer">
                    <CustomHeader title="events" first_button_text="+ Add Event" first_button_type="primary" onClickFirstButton={this.handleCreateEvent} search_placeholder="Search Events" onChangeSearch={this.handleEventSearch} bottom_bordered show_first_button show_search />
                    <Table className="ori-card-row-table" rowClassName="ori-bg-white ori-border-radius-4 ori-box-shadow-light" scroll={{ x: 600 }} size={mobile ? "small" : "middle"} rowKey={uniqueId} columns={this.columns} dataSource={this.state.filtered_events} />
                    <Modal className="ori-modal-primary" title={modal_data.title} footer={null} visible={modal_data.show_create_event || modal_data.show_edit_event} maskClosable={false} onCancel={this.closeModal} >
                        {this.renderEventCommonForm()}
                    </Modal>
                </Row>
            );
        }
        else if (!event_details.loaders.events_loading && !event_details.loaders.events_loaded) {
            return (
                <ShowMessage img_src={IMG_ERROR} title="Error" message="unable to load workflow details. please check your intenet connection and reload the page." height={150} width={150} />
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        page_details: state.page_details,
        event_details: state.event_details
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, pageActions, eventActions), dispatch)
    };
}

Events.propTypes = {
    actions: PropTypes.object,
    page_details: PropTypes.object,
    event_details: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    isActionPermitted: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Events);

const options = ['start', 'end', 'success', 'failure'];



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/events/index.js